function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var ces = function ces(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9654 38.9998V20.0173L19.4654 13.3389L26.9654 20.0173V38.9998H11.9654Z",
    stroke: "black",
    strokeWidth: "1.99999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "17",
    y: "30.4735",
    width: "5.36842",
    height: "8.52631",
    stroke: "black",
    strokeWidth: "1.99999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "5.21038",
    y: "24.1577",
    width: "3.26316",
    height: "3.26316",
    stroke: "black",
    strokeWidth: "1.99999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "31.526",
    y: "24.1577",
    width: "3.26316",
    height: "3.26316",
    stroke: "black",
    strokeWidth: "1.99999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "5.21038",
    y: "31.5261",
    width: "3.26316",
    height: "3.26316",
    stroke: "black",
    strokeWidth: "1.99999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "31.526",
    y: "31.5261",
    width: "3.26316",
    height: "3.26316",
    stroke: "black",
    strokeWidth: "1.99999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 19.9472H39.0001V38.9998H27V19.9472Z",
    stroke: "black",
    strokeWidth: "1.99999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999995 19.9472H12V38.9998H0.999995V19.9472Z",
    stroke: "black",
    strokeWidth: "1.99999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2137 20.7841V27.0695H19.0166V25.7314H16.851V24.4814H18.8053V23.1961H16.851V22.1221H18.9374V20.7841H15.2137ZM22.0625 22.5975H23.5942C23.5942 21.9226 23.4328 21.4326 23.11 21.1274C22.7931 20.8164 22.2767 20.6608 21.5607 20.6608C20.8682 20.6608 20.3517 20.8281 20.0114 21.1626C19.671 21.4971 19.5008 21.9842 19.5008 22.6239C19.5008 22.9936 19.5624 23.293 19.6856 23.5218C19.8147 23.7507 19.9732 23.9356 20.161 24.0764C20.3547 24.2173 20.563 24.3317 20.786 24.4197C21.009 24.5078 21.2144 24.5958 21.4022 24.6838C21.5959 24.766 21.7544 24.8687 21.8776 24.9919C22.0067 25.1093 22.0713 25.2707 22.0713 25.4761C22.0713 25.6463 22.0243 25.7901 21.9304 25.9075C21.8424 26.0248 21.7133 26.0835 21.5431 26.0835C21.3846 26.0835 21.2555 26.0307 21.1558 25.9251C21.056 25.8136 21.0061 25.6228 21.0061 25.3529V25.2032H19.4215V25.4233C19.4215 25.7519 19.4685 26.0278 19.5624 26.2508C19.6563 26.4738 19.7913 26.6557 19.9673 26.7966C20.1493 26.9316 20.3693 27.0255 20.6276 27.0783C20.8917 27.137 21.1939 27.1663 21.5343 27.1663C22.2561 27.1663 22.8078 27.0167 23.1893 26.7174C23.5707 26.4122 23.7615 25.9251 23.7615 25.256C23.7615 24.8746 23.694 24.5665 23.559 24.3317C23.4299 24.0911 23.2656 23.8974 23.066 23.7507C22.8665 23.604 22.6523 23.4866 22.4234 23.3986C22.1945 23.3047 21.9803 23.2137 21.7808 23.1257C21.5812 23.0377 21.414 22.935 21.279 22.8176C21.1499 22.6943 21.0853 22.53 21.0853 22.3246C21.0853 22.1838 21.1264 22.0576 21.2086 21.9461C21.2907 21.8287 21.4198 21.77 21.5959 21.77C21.7544 21.77 21.8717 21.8375 21.948 21.9725C22.0243 22.1016 22.0625 22.2601 22.0625 22.4479V22.5975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1442 5.53302V5.97302H22.1242V5.47802C22.1242 5.09669 22.0765 4.75569 21.9812 4.45502C21.8932 4.14703 21.7465 3.88669 21.5412 3.67403C21.3432 3.45403 21.0829 3.28536 20.7602 3.16803C20.4375 3.0507 20.0452 2.99203 19.5832 2.99203C19.0552 2.99203 18.6115 3.06537 18.2522 3.21203C17.8929 3.35136 17.6032 3.58236 17.3832 3.90503C17.1632 4.22769 17.0056 4.64936 16.9102 5.17002C16.8222 5.69069 16.7782 6.32502 16.7782 7.07301C16.7782 7.80634 16.8149 8.43334 16.8882 8.954C16.9689 9.46733 17.1119 9.889 17.3172 10.219C17.5226 10.5417 17.8085 10.7727 18.1752 10.912C18.5419 11.0513 19.0112 11.121 19.5832 11.121C19.9132 11.121 20.2322 11.0843 20.5402 11.011C20.8555 10.945 21.1342 10.813 21.3762 10.615C21.6182 10.4097 21.8125 10.131 21.9592 9.779C22.1059 9.427 22.1792 8.976 22.1792 8.42601V7.84301H20.1992C20.1992 8.21701 20.1882 8.52867 20.1662 8.778C20.1515 9.02 20.1222 9.21433 20.0782 9.361C20.0342 9.50767 19.9719 9.614 19.8912 9.68C19.8105 9.73867 19.7079 9.768 19.5832 9.768C19.4292 9.768 19.3045 9.72767 19.2092 9.647C19.1212 9.56633 19.0515 9.42333 19.0002 9.218C18.9562 9.01267 18.9269 8.73767 18.9122 8.39301C18.8975 8.04101 18.8902 7.60101 18.8902 7.07301C18.8902 6.54501 18.8975 6.10868 18.9122 5.76402C18.9269 5.41202 18.9562 5.13335 19.0002 4.92802C19.0515 4.72269 19.1212 4.57969 19.2092 4.49902C19.3045 4.41836 19.4292 4.37803 19.5832 4.37803C19.7812 4.37803 19.9242 4.45869 20.0122 4.62002C20.1002 4.78136 20.1442 5.08569 20.1442 5.53302Z",
    fill: "black"
  }));
};

export default ces;